'use es6';

const BLACK = '#111111';
const WHITE = '#FFFFFF';
const YIQ_THRESHOLD = 186;

export default (backgroundColor) => {
  if (backgroundColor === null) {
    return WHITE;
  }

  if (backgroundColor && backgroundColor[0] === '#') {
    backgroundColor = backgroundColor.slice(1);
  }

  const isFullHexValue = backgroundColor.length === 6;
  const rStr = isFullHexValue
    ? backgroundColor.substring(0, 2)
    : `${backgroundColor[0]}${backgroundColor[0]}`;
  const gStr = isFullHexValue
    ? backgroundColor.substring(2, 4)
    : `${backgroundColor[1]}${backgroundColor[1]}`;
  const bStr = isFullHexValue
    ? backgroundColor.substring(4, 6)
    : `${backgroundColor[2]}${backgroundColor[2]}`;

  const r = parseInt(rStr, 16);
  const g = parseInt(gStr, 16);
  const b = parseInt(bStr, 16);

  // Using YIQ function: https://24ways.org/2010/calculating-color-contrast/
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;

  return yiq >= YIQ_THRESHOLD ? BLACK : WHITE;
};
